
interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

const LoadingSpinner = ({ size = 'medium', className = '' }: LoadingSpinnerProps) => {
  const sizeClasses = {
    small: 'h-8 w-8',
    medium: 'h-16 w-16',
    large: 'h-24 w-24',
  };

  return (
    <div className="flex items-center justify-center">
      <div className="relative">
        <div className={`${sizeClasses[size]} ${className} rounded-full border-t-2 border-b-2 border-accent animate-spin`}></div>
        <div className={`absolute top-0 left-0 ${sizeClasses[size]} ${className} rounded-full border-t-2 border-b-2 border-accent/30 animate-pulse`}></div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
